import type { FaireProductEntity } from "../../entity_types/product";

export const sweet_wink_5: FaireProductEntity = {
  token: "sweet-wink-5",
  type: "product",
  name: "Sweet Wink Gold Top Hangers - 12 Pack - Children's Hanger",
  brandName: "Sweet Wink",
  imageUrl:
    "https://cdn.faire.com/fastly/5def6e2d850b81be777d2f2395be3e4aed4612a387c38927e9d98e96e12b0f68.jpeg?bg-color=FFFFFF&dpr=1&fit=crop&format=jpg&height=720&width=720",
  priceDollars: 12,
  msrpDollars: 24,
  freeShipping: false,
  isBestseller: false,
  description: "",
  categoryTokens: ["cat_kids-all"],
  tags: [],
  inStock: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "legacy-products-migration",
  },
};
